import React from 'react'
import { Link } from 'gatsby'
import { Button, Box, Heading, Text } from 'theme-ui'

/**
 * Shadow me to add your own content
 */

const styles = {
  author: {
    display: `inline-block`,
    color: `alpha`
  },
  occupation: {
    mb: 4
  },
  specialty: {
    color: `text`,
    mb: 4
  }
}

export default () => (
  <>
    <Heading variant='h1'>
      Herzlich Willkommen!
    </Heading>
    <Box variant='buttons.group'>
      <Button as={Link} to='/contact'>
        Kontakt
      </Button>
      <Button variant='white' as={Link} to='/about'>
        Über mich
      </Button>
    </Box>
  </>
)
